import { AppProvider } from './provider'
import { AppRouter } from './router'

// ErrorBoundayでは補足できないエラーのハンドリング
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (
      event.message?.includes('Loading chunk') ||
      event.message?.includes(
        "Cannot read properties of undefined (reading 'call')",
      )
    ) {
      window.location.reload()
    }
  })

  window.addEventListener('unhandledrejection', (event) => {
    // reasonがErrorオブジェクトでない場合の処理
    const message =
      event.reason instanceof Error
        ? event.reason.message
        : String(event.reason || '')

    if (
      message?.includes('Loading chunk') ||
      message?.includes("Cannot read properties of undefined (reading 'call')")
    ) {
      window.location.reload()
    }
  })
}

export const App = () => {
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  )
}
